module.exports = {"title":"Week 2: Meeting Ana","body":"<p>We confirmed that we would be working with Dr. Sirovic early this week.  We created our project overview presentation, and began looking into the background of what skills and knowledge we would need to complete our project.</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./process/week-2/index.md
// module id = 493
// module chunks = 0